import clsx from "clsx";

/** @param  {...unknown} inputs */
export function cn(...inputs) {
  return clsx(inputs);
}
